var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsSettings = function SvgFormsSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.308 7.293a3.623 3.623 0 005.385 0l1.752-1.923a3.628 3.628 0 016.314 2.617l-.131 2.593a3.625 3.625 0 003.798 3.803l2.593-.131a3.629 3.629 0 012.61 6.315l-1.929 1.74a3.628 3.628 0 000 5.387l1.93 1.741a3.627 3.627 0 01-2.617 6.315l-2.593-.132a3.624 3.624 0 00-3.807 3.808l.132 2.593a3.627 3.627 0 01-6.3 2.61l-1.743-1.927a3.627 3.627 0 00-5.385 0l-1.75 1.928a3.628 3.628 0 01-6.308-2.608l.134-2.592a3.627 3.627 0 00-3.808-3.808l-2.592.132a3.627 3.627 0 01-2.623-6.31l1.928-1.74a3.63 3.63 0 000-5.387l-1.928-1.75a3.626 3.626 0 012.61-6.308l2.592.132a3.626 3.626 0 003.811-3.815L14.26 7.98a3.628 3.628 0 016.308-2.61l1.74 1.922z",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 25.002a8.333 8.333 0 1016.666 0 8.333 8.333 0 00-16.666 0v0z",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFormsSettings;